import React from 'react';
import { Box } from '@mui/material';

import { Rows } from './Rows';
import { RowsGroup } from './RowsGroup';
import { Column, Group, ListingEvent, StaticSettings } from '../types';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  tableData: Data[];
  groups?: Group<Data>[];
  staticSettings?: StaticSettings;
  columns: Column<Data, Context>[];
  onEmit?: (event: ListingEvent, data?: unknown) => void;
}

export const TableBody = <Data extends Record<string, any>, Context extends any = any>({
  groups,
  onEmit,
  columns,
  context,
  tableData,
  staticSettings,
}: Props<Data, Context>) => {
  if (groups)
    return (
      <RowsGroup
        groups={groups}
        onEmit={onEmit}
        columns={columns}
        context={context}
        staticSettings={staticSettings}
        key={staticSettings?.allGroupsOpen?.toString()}
      />
    );

  return (
    <Box>
      <Rows tableData={tableData} context={context} columns={columns} />
    </Box>
  );
};
